import React, { useEffect, useRef, useState } from 'react';
import { isConsentGiven } from './utils';
import { CmpContext, CmpContextValue } from './context';

const cookieCheckInterval = 10 * 1000; // 10 seconds

export const CmpProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const [consent, setConsent] = useState<CmpContextValue>({
    consentGiven: isConsentGiven(),
  });

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      const consentGiven = isConsentGiven();

      if (consent.consentGiven !== consentGiven) {
        setConsent({ consentGiven });
      }
    }, cookieCheckInterval);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [consent]);

  return (
    <CmpContext.Provider value={{ ...consent }}>{children}</CmpContext.Provider>
  );
};
